import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, BookOpen, Compass, User } from 'lucide-react';

// v2 design (2026-05-30): four tabs with the new label set. The Search
// screen is repurposed as Discover — same route key, different label +
// icon for now. A future PR can rewrite the screen body itself.
const tabs = [
  { path: '/app/home',    label: 'Home',     icon: Home },
  { path: '/app/library', label: 'Library',  icon: BookOpen },
  { path: '/app/search',  label: 'Discover', icon: Compass },
  { path: '/app/profile', label: 'Profile',  icon: User },
];

const BRAND = '#5B47E0';

const BottomTabBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div
      className="bg-white border-t safe-area-bottom"
      style={{ borderColor: '#E2E8F0' }}
    >
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const isActive = location.pathname.startsWith(tab.path);
          const Icon = tab.icon;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className="flex flex-col items-center justify-center gap-1 w-16 h-full transition-colors"
              style={{ color: isActive ? BRAND : '#94A3B8' }}
            >
              <Icon
                className="w-[22px] h-[22px]"
                strokeWidth={isActive ? 2.4 : 1.8}
              />
              <span
                className="text-[11px]"
                style={{ fontWeight: isActive ? 600 : 500 }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomTabBar;
